const NotFoundSticker = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={300}
      height={308}
      viewBox="0 0 300 308"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <ellipse cx="150" cy="290.523" rx="150" ry="17.3355" fill="#3D5373" />
      <path
        d="M90 241.884C90 208.641 116.949 181.691 150.193 181.691C183.436 181.691 210.385 208.641 210.385 241.884V287.63H90V241.884Z"
        fill="#051F46"
      />
      <path
        d="M156.693 273.184C175.613 273.184 193.715 273.589 210.386 274.328V306.709C194.399 307.417 177.096 307.82 159.017 307.852H154.371C131.272 307.811 109.439 307.167 90.0001 306.05V274.988C110.089 273.834 132.735 273.184 156.693 273.184Z"
        fill="#051F46"
      />
      <circle cx="172.229" cy="263.409" r="12.4095" fill="white" />
      <circle cx="172.229" cy="265.878" r="3.87797" fill="#051F46" />
      <circle
        cx="12.4095"
        cy="12.4095"
        r="12.4095"
        transform="matrix(-1 0 0 1 140.819 251)"
        fill="white"
      />
      <circle
        cx="3.87797"
        cy="3.87797"
        r="3.87797"
        transform="matrix(-1 0 0 1 132.288 262)"
        fill="#051F46"
      />
      <mask
        id="mask0_986_15663"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="54"
        y="16"
        width="192"
        height="235"
      >
        <path
          d="M243.98 202.517C246.788 207.238 244.111 213.319 238.733 214.438L64.0977 250.754C58.7199 251.873 53.8405 247.363 54.5327 241.914L81.2779 31.3648C81.7083 27.9769 84.2418 25.2358 87.5853 24.5405L127.007 16.3424C130.35 15.6471 133.767 17.1509 135.512 20.0864L243.98 202.517Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_986_15663)">
        <rect
          x="-3.39331"
          y="43.4609"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 -3.39331 43.4609)"
          fill="#C678D9"
        />
        <rect
          x="14.2545"
          y="128.32"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 14.2545 128.32)"
          fill="#C678D9"
        />
        <rect
          x="5.43066"
          y="85.8906"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 5.43066 85.8906)"
          fill="white"
        />
        <rect
          x="23.0781"
          y="170.754"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 23.0781 170.754)"
          fill="white"
        />
        <rect
          x="31.902"
          y="213.184"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 31.902 213.184)"
          fill="#C678D9"
        />
      </g>
      <rect
        x="12.6914"
        y="257.836"
        width="287.619"
        height="26.0032"
        rx="13.0016"
        transform="rotate(-11.7477 12.6914 257.836)"
        fill="#BE68D3"
      />
    </svg>
  );
};

export default NotFoundSticker;
